import React from 'react';
import { TrendingUp, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const ForecastAnalysis = () => {
  return (
    <>
      {/* Breadcrumb - Outside page-container to align with sidebar */}
      <PageBreadcrumb />
      {/* Page Header - Outside page-container to align with sidebar */}
      <PageHeader 
        title="Forecast Analysis"
        description="Advanced forecasting models for financial planning"
      />
      <div className="page-container" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-blue-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <TrendingUp size={48} className="text-blue-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Financial Forecasting</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Advanced forecasting models with AI-powered predictions for financial planning. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> AI-powered financial forecasting with predictive analytics, 
                scenario planning, and automated trend analysis.
              </p>
            </div>

            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center mx-auto">
              <TrendingUp size={20} className="mr-2" />
              Generate Forecast
            </button>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default ForecastAnalysis;
